import { gql } from '@apollo/client'

export const DELETE_MEDIA_OBJECT_MUTATION = gql`
  mutation DeleteMediaObject($input: deleteMediaObjectInput!) {
    deleteMediaObject(input: $input) {
      mediaObject {
        id
      }
    }
  }
`
